import { RouteObject } from 'react-router-dom';
import { CandidateAppliedView } from './feature-job-applied-view';
import { FeatureManageAlerts } from './feature-manage-alerts';
import { FeatureManageCvs } from './feature-manage-cv';

export const CANDIDATE_ROUTES: RouteObject[] = [
   {
      path: '/alerts/index',
      Component: FeatureManageAlerts,
   },

   {
      path: '/candidates/my-cv-list',
      Component: FeatureManageCvs,
   },
   {
      path: '/candidates/job-applied-view/:id',
      Component: CandidateAppliedView,
   }
];
